<!--
 - Author : wanghongling.
 - Date   : 2019/7/12.
 - File   : twoLine.两条折线
 -->

<template>
  <div :id="id" :style="{width: '100%', height: waveList.height, margin: waveList.margin}">
  </div>
</template>

<script>
  export default {
    name: 'wave-bar',
    data() {
      return {
      }
    },
    props: {
      id: {
        type: String,
        default: 'test'
      },
      waveList: {
        dw: 'w'
      }
    },
    watch: {
      waveList: {
        handler() {
          this.$nextTick(() => {
            this.makeWave()
          })
        },
        deep: true
      }
    },
    mounted() {
      this.init()
    },
    destroyed() {
      // window.removeEventListener('resize', this.resizeEvent)
      this.$echarts.dispose(this.myWave)
      this.myWave = null
    },
    methods: {
      /**
       * 初始化echart
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      init() {
        this.myWave = this.$echarts.init(document.getElementById(this.id))
        this.makeWave()
      },
      /**
       * echart数据赋值
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      makeWave() {
        let settingArr = []
        // 设置监测阈值的线
        if (this.waveList.markLineShow) {
          this.waveList.settingArr.map(v => {
            let tmp = [{
              symbol: 'none',
              xAxis: v.beginTime,
              // x: v.beginTime,
              yAxis: v.powerPeakUpper
            }, {
              symbol: 'none',
              xAxis: v.endTime,
              // x: v.endTime,
              yAxis: v.powerPeakUpper,
              label: {
                normal: {
                  position: 'middle',
                  formatter: function(e) {
                    // console.error('JSON.stringify(e)', JSON.stringify(e), JSON.parse(JSON.stringify(e)))
                    return e.data.yAxis
                  },
                  show: this.waveList.markLineShow || false
                }
              }
            }]
            settingArr.push(tmp)
          })
        }
        let formatter
        if (this.waveList.formatter) {
          formatter = '{b}{a0}：{c0}' + this.waveList.dw
        } else {
          formatter = '{b}:00{a0}：{c0}' + this.waveList.dw
        }
        let option = {
          backgroundColor: this.waveList.backgroundColor || '',
          title: this.waveList.title || '',
          tooltip: {
            trigger: 'axis', // 触发类型。[ default: 'item' ] :数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用;'axis'坐标轴触发，主要在柱状图，折线图等会使用类目轴的图表中使用
            axisPointer: {
              lineStyle: {
                color: this.waveList.ySplitColor || '#014778'
              }
            },
            formatter: function() { // 去除光标选中默认样式
              var res = ''
              return res
            }
          },
          grid: {
            top: this.waveList.gridTop || '0%',
            left: '15', // grid 组件离容器左侧的距离。
            right: this.waveList.gridRight || '0%', // grid 组件离容器右侧的距离。
            bottom: '0%', // grid 组件离容器下侧的距离。
            containLabel: true // grid 区域是否包含坐标轴的刻度标签[ default: false ]
          },
          xAxis: [{
            type: 'category',
            boundaryGap: true, // 坐标轴两边留白策略，类目轴和非类目轴的设置和表现不一样
            axisLine: {
              lineStyle: {
                color: this.waveList.xLineColor || '#00d6ff'// 坐标轴线线的颜色。
              }
            },
            data: this.waveList.xData
          }],
          yAxis: [{
            type: 'value', // 坐标轴类型。'value' 数值轴，适用于连续数据;'category' 类目轴，适用于离散的类目数据，为该类型时必须通过 data 设置类目数据;'time' 时间轴;'log' 对数轴.
            name: this.waveList.yAxisName || '', // 坐标轴名称。
            axisTick: {
              show: false // 是否显示坐标轴刻度
            },
            axisLine: {
              lineStyle: {
                color: this.waveList.yLineColor || '#00d6ff'// 坐标轴线线的颜色
              }
            },
            axisLabel: {
              margin: this.waveList.axisLabel.margin || 10, // 刻度标签与轴线之间的距离
              textStyle: {
                fontSize: this.waveList.axisLabel.fontSize || 16 // 文字的字体大小
              }
            },
            splitLine: {// 分隔线设置
              show: true,
              lineStyle: {
                color: [this.waveList.xSplitColor],
                width: 1,
                type: 'solid'
              }
            }
            // data: this.waveList.yCategory
          }],
          series: [ {
            name: '',
            type: 'line',
            smooth: true,
            symbol: '',
            symbolSize: 5,
            showSymbol: false,
            lineStyle: {
              normal: {
                width: 1,
                color: '#13ff00'
              }
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: 'rgba(19, 255, 0, 0.3)'
                }, {
                  offset: 0.8,
                  color: 'rgba(19, 255, 0, 0)'
                }], false),
                shadowColor: 'rgba(0, 0, 0, 0.1)',
                shadowBlur: 10
              }
            },
            animationDuration: 3000,
            animationDurationUpdate: 3000,
            itemStyle: {
              normal: {
                color: 'rgb(19,255,0)',
                borderColor: 'rgba(19,255,0,0.2)',
                borderWidth: 12

              }
            },
            label: {
              show: false,
              distance: 1,
              emphasis: {
                show: true,
                offset: [0, 0],
                backgroundColor: {
                  // image: require('../../assets/images/river/data.png')
                },
                color: '#FFF',
                padding: [5, 5, 0, 15],
                height: 14,
                width: 25,
                formatter: formatter,
                rich: {
                }
              }
            },
            data: this.waveList.data,
            markLine: {
              lineStyle: {
                color: '#ffc832',
                opacity: this.waveList.markLineOpacity || 0
              },
              data: settingArr
            }
          }]
        }
        this.myWave.setOption(option)
        // window.addEventListener('resize', this.resizeEvent)
      },
      /**
       * echart图表适应
       * @author: whl
       * @createDate: 2019/8/9
       * @return {Object}
       */
      resizeEvent() {
        this.myWave.resize() // 使图表适应
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/echarts/waveBar.vue